import src from "IMAGE";
export default { src, width: 516, height: 242, blurDataURL: null, blurWidth: 0, blurHeight: 0 }
